import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface RetryPasswordDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (password: string) => void;
  disabled: boolean;
  legacyUsername: string;
  legacyServer: string;
  skippedCount: number;
}

export function RetryPasswordDialog({
  open,
  onClose,
  onConfirm,
  disabled,
  legacyUsername,
  legacyServer,
  skippedCount,
}: RetryPasswordDialogProps) {
  const [password, setPassword] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length > 0) {
      onConfirm(password);
      setPassword('');
    }
  };

  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      setPassword('');
      onClose();
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Retry Skipped Items</DialogTitle>
          <DialogDescription>
            Re-authenticate to import {skippedCount} skipped item{skippedCount !== 1 ? 's' : ''}{' '}
            from {legacyUsername} ({legacyServer}).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <Label htmlFor="retry-password">Legacy Password</Label>
              <Input
                id="retry-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your legacy password"
                disabled={disabled}
              />
            </div>
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={disabled}>
              Cancel
            </Button>
            <Button type="submit" disabled={disabled || password.length === 0}>
              {disabled ? 'Retrying...' : 'Retry Import'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
